import React from 'react';
import PropTypes from 'prop-types';
import './ManagedWindow.css';

class ManagedWindow extends React.Component {
    getChildContext() {
        return {
            active: this.props.active
        };
    }
    render() {
        const styles = {
            top: `${this.props.top}px`,
            left: `${this.props.left}px`,
            zIndex: this.props.index,
            width: `${this.props.width}px`
        };
        return (
            <div className="ManagedWindow"
                 style={styles}
                 onMouseDown={this.props.onMouseDown}>
                {this.props.children}
            </div>
        );
    }
}

ManagedWindow.propTypes = {
    children: PropTypes.any,
    active: PropTypes.bool,
    top: PropTypes.number,
    left: PropTypes.number,
    index: PropTypes.number,
    width: PropTypes.number,
    onMouseDown: PropTypes.func
};

ManagedWindow.childContextTypes = {
    active: PropTypes.bool
};

export default ManagedWindow;



// WEBPACK FOOTER //
// ./src/components/WindowManager/ManagedWindow.jsx